<template>
  <div>
    <a @click="fnShowModal()" class="p-2"
      ><i class="far fa-edit text-primary"></i
    ></a>

    <b-modal ref="modal" size="sm" hide-footer title="Designation - Edit">
      <div class="d-block">
        <form>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="name"
                />
                <label class="floatingLabel" for="name">Designation</label>
                <div class="invalid-feedback" v-if="errors.name">
                  {{ errors.name[0] }}
                </div>
              </div>
            </div>

            <div class="col-12">
              <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="Y"
                unchecked-value="N"
              >
                Status
              </b-form-checkbox>
            </div>
          </div>

          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="update()"
            >
              <b-spinner v-if="isSpinner" small class="mr-2"></b-spinner>Save
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import * as messageService from '../../services/message.service'
import * as designationService from '../../services/designation.service'
export default {
  name: 'ModalDesignationEdit',
  props: ['propsData'],
  components: {},
  data() {
    return {
      errors: {},
      name: '',
      status: '',
      isSpinner: false
    }
  },
  computed: {
    ...mapGetters(['getDesignationPaginate'])
  },
  methods: {
    ...mapActions(['fetchDesignationPaginate']),
    fnShowModal() {
      this.fnGetValue(this.propsData)
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },
    fnGetValue(props) {
      this.id = props.id
      this.name = props.name
      this.status = props.status
    },

    update: async function () {
      this.isSpinner = true

      try {
        let formData = new FormData()
        formData.append('name', this.name)
        formData.append('status', this.status)
        const response = await designationService.update(this.id, formData)

        this.fetchDesignationPaginate(this.getDesignationPaginate)
        this.hideModal()

        messageService.fnSweetAlertSuccessToast(
          'Designation - Edit',
          'update successfully'
        )

        this.name = ''
        this.isSpinner = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Designation - Edit',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Designation - Edit',
              'Something wrong'
            )
            break
        }
        this.isSpinner = false
      }
    }
  }
}
</script>
